import { defineMessages } from "@formatjs/intl";

const messages = defineMessages({
  requiredDesiredDate: {
    id: "BookVisit.Message.RequiredDesiredDate",
    defaultMessage: "Please select your desired date.",
    description:
      "The error message for required desired date on book visit form",
  },
  requiredDesiredTime: {
    id: "BookVisit.Message.RequiredDesiredTime",
    defaultMessage: "Please select your desired time frame.",
    description:
      "The error message for required desired time on book visit form",
  },
  requiredField: {
    id: "BookVisit.Message.RequiredField",
    defaultMessage: "This is a required field",
    description: "The error message for required field on book visit form",
  },
  required: {
    id: "BookVisit.Message.Required",
    defaultMessage: "Required",
    description: "The error message for required on book visit form",
  },
  invalidJapaneseName: {
    id: "BookVisit.Message.InvalidJapaneseName",
    defaultMessage:
      "お名前を全角漢字（スペースを入れる場合は半角スペース）で入力してください。",
    description:
      "The error message for invalid Japanese name on book visit form",
  },
  invalidKanaName: {
    id: "BookVisit.Message.InvalidKanaName",
    defaultMessage:
      "お名前のフリガナを全角カタカナ（スペースを入れる場合は半角スペース）で入力してください。",
    description: "The error message for invalid kana name on book visit form",
  },
  invalidName: {
    id: "BookVisit.Message.InvalidName",
    defaultMessage:
      "Please enter your name (half-width space if you want to insert a space).",
    description: "The error message for invalid name on book visit form",
  },
  invaildTelephone: {
    id: "BookVisit.Message.InvalidTelephone",
    defaultMessage:
      "Please enter a 10 or 11-digit telephone number using half-width numeric characters, starting with a 0 (excluding hyphens).",
    description: "The error message for invalid telephone on book visit form",
  },
  invalidEmail: {
    id: "BookVisit.Message.InvalidEmail",
    defaultMessage:
      "Please enter your email address in half-width alphanumerical characters.",
    description: "The error message for invalid email on book visit form",
  },
  invalidConfirmEmail: {
    id: "BookVisit.Message.InvalidConfirmEmail",
    defaultMessage: "Email address does not match.",
    description:
      "The error message for invalid confirm email on book visit form",
  },
  submitError: {
    id: "BookVisit.Message.SubmitError",
    defaultMessage: "Service temporarily unavailable. Please try again later.",
    description: "The error message for submit error on book visit form",
  },
  selectDate1: {
    id: "BookVisit.Message.SelectDate1",
    defaultMessage: "Select the visit date and time<br />(1st preference)",
    description: "The label for 1st preference datepicker on book visit form",
  },
  selectDate2: {
    id: "BookVisit.Message.SelectDate2",
    defaultMessage: "Select the visit date and time<br />(2nd preference)",
    description: "The label for 2nd preference datepicker on book visit form",
  },
  selectDate3: {
    id: "BookVisit.Message.SelectDate3",
    defaultMessage: "Select the visit date and time<br />(3rd preference)",
    description: "The label for 3rd preference datepicker on book visit form",
  },
});

export default messages;
